'use strict';

var ItemHighlighter = function () {
    this.initialize();
};

ItemHighlighter.prototype = {

    _itemsToHighlight: {},  // map from keys to the IDs of elements that should be highlighted for each
    _currentlyHighlighted: null,

    highlightCss: 'hover',

    initialize: function () {
    },

    addItemToHighlight: function (key, itemId) {
        if (!document.getElementById(itemId)) {
            return;
        }

        var items = this._itemsToHighlight[key];
        if (items == null) {
            items = new Array();
            this._itemsToHighlight[key] = items;
        }
        var index = items.indexOf(itemId);
        if (index < 0) {
            this._itemsToHighlight[key].push(itemId);
            if (this._currentlyHighlighted === key) {
                MITS.jQueryById(itemId).addClass(this.highlightCss);
            }
        }
    },

    removeItemToHighlight: function (key, itemId) {
        var $item =  MITS.jQueryById(itemId);
        if ($item.length === 0) {
            return;
        }

        var items = this._itemsToHighlight[key];
        if (items != null) {
            var index = items.indexOf(itemId);
            if (index >= 0) {
                items.splice(index, 1);
                this._itemsToHighlight[key] = items;
            }

            if (this._currentlyHighlighted === key) {
                $item.removeClass(this.highlightCss);
            }
        }
    },


    toggleHighlighting: function (key) {
        if (this._currentlyHighlighted !== key) {
            this.unHighlightItems(this._currentlyHighlighted);
            this.highlightItems(key);
        } else {
            this._currentlyHighlighted = null;
            this.unHighlightItems(key);
        }
    },

    highlightItems: function (key) {
        this._currentlyHighlighted = key;

        MITS.jQueryById(key + '_mouseover').addClass("active");

        var items = this._itemsToHighlight[key];
        if (items != null) {
            var numItems = items.length;
            for (var i = 0; i < numItems; i++) {
                var $item = MITS.jQueryById(items[i]);
                if ($item.length) { // guard against element ids that aren't actually there
                    if (!$item.hasClass(this.highlightCss)) {
                        $item.addClass(this.highlightCss);
                    }
                }
            }
        }
    },

    unHighlightItems: function (key) {
        if (key == null) return;

        MITS.jQueryById(key + '_mouseover').removeClass("active");

        var items = this._itemsToHighlight[key];
        if (items != null) {
            var numItems = items.length;
            for (var i = 0; i < numItems; i++) {
                var $item = MITS.jQueryById(items[i]);
                if ($item.length) {
                    if ($item.hasClass(this.highlightCss)) {
                        $item.removeClass(this.highlightCss);
                    }
                }
            }
        }
    }
};

module.exports = ItemHighlighter;


//////////////////
// WEBPACK FOOTER
// ./mits/UI/ItemHighlighter.js
// module id = 27
// module chunks = 0